import "../styles/about.css";
import { aboutTeam } from "../assets/images";

const team = [
  { name: "Alex Poole", role: "Owner", emoji: "👨‍🔧" },
  { name: "Austin Freeland", role: "Owner", emoji: "👨‍🔧" },
];

const values = [
  { icon: "🎯", title: "Precision", desc: "Every service is performed to spec — no shortcuts, no guesswork." },
  { icon: "⚡", title: "Efficiency", desc: "We respect your time and work hard to minimize downtime." },
  { icon: "🤝", title: "Integrity", desc: "Honest pricing, transparent communication, and quality you can verify." },
  { icon: "💪", title: "Reliability", desc: "When we commit to a job, it gets done — on time, every time." },
];

export default function About() {
  return (
    <div>
      <div className="about__hero">
        <p className="about__hero-eyebrow">OUR STORY</p>
        <h1 className="about__hero-title">About Race City Truck Solutions</h1>
      </div>
      <div className="about__content">
        <div className="about__mission">
          <div className="about__mission-text-block">
            <p className="about__mission-eyebrow">OUR MISSION</p>
            <h2 className="about__mission-title">Built for the Long Haul</h2>
            <p className="about__mission-text">Race City Truck Solutions was born from a deep respect for the men and women who keep America's goods moving. Founded in Statesville, NC, we bring a racing mindset to commercial truck maintenance: precision, speed, and zero tolerance for failure.</p>
            <p className="about__mission-text">We started small, serving local owner-operators, and have grown into a trusted partner for fleet managers across the region. Show up, do the job right, and stand behind our work every single time.</p>
          </div>
          <div className="about__mission-img">
            <img src={aboutTeam} alt="Race City Truck Solutions team" />
          </div>
        </div>

        <div className="about__values">
          <div className="about__values-header">
            <p className="about__values-eyebrow">WHAT DRIVES US</p>
            <h2 className="about__values-title">Our Core Values</h2>
          </div>
          <div className="about__values-grid">
            {values.map(({ icon, title, desc }) => (
              <div key={title} className="about__value">
                <div className="about__value-icon">{icon}</div>
                <div className="about__value-title">{title}</div>
                <p className="about__value-desc">{desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="about__team-header">
          <p className="about__team-eyebrow">THE TEAM</p>
          <h2 className="about__team-title">The People Behind the Wrenches</h2>
        </div>
        <div className="about__team-grid">
          {team.map((m) => (
            <div key={m.name} className="about__team-card">
              <div className="about__team-emoji">{m.emoji}</div>
              <div className="about__team-name">{m.name}</div>
              <div className="about__team-role">{m.role}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}